module.exports = __webpack_public_path__ + "static/media/iconPaso1.e9f6ca11.svg";